import { Col, Input, Row } from 'antd';
import { Flex } from '@/components';
import { useUniversityContext, useUserContext } from '@/context';
import { useTranslation } from 'react-i18next';

const gap = 24;

export const ProfileInfo = () => {

  const [t] = useTranslation(['common']);
  const { profile } = useUserContext();
  const { university } = useUniversityContext();
  const { student } = profile ?? {};

  return (
    <Flex direction="column" className="w-full text-base" gap={gap}>
      <Row className="w-full" gutter={[gap, gap]}>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.firstname')}</label>
          <Input value={profile?.firstName} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.lastname')}</label>
          <Input value={profile?.lastName} disabled />
        </Col>
      </Row>
      <Row className="w-full" gutter={[gap, gap]}>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.university')}</label>
          <Input value={university?.universityLabel} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.grade')}</label>
          <Input value={student?.studyLevel?.name} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.study-major')}</label>
          <Input value={student?.studyMajor?.name} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.study-major-field')}</label>
          <Input value={student?.studyMajor?.description} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.entrance-type')}</label>
          <Input value={student?.entranceType} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.status-of', { value: t('common:labels.dormitory') })}</label>
          <Input
            disabled
            value={student?.isDormitoryResident ?
              t('common:labels.has-accommodation') :
              t('common:labels.no-accommodation')
            }
          />
        </Col>
      </Row>
      <Row className="w-full" gutter={[gap, gap]}>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.mobile-no')}</label>
          <Input value={profile?.mobileNumber} disabled />
        </Col>
        <Col xl={6} lg={8} span={12}>
          <label>{t('common:labels.email')}</label>
          <Input value={profile?.email} disabled />
        </Col>
      </Row>
    </Flex>
  );
};

export default ProfileInfo;
